import React, { useState, useEffect } from 'react';
import { useLanguage } from '../utils/LanguageContext';
import { createWish, getWishes, Wish } from '../utils/api';

const SendWish: React.FC = () => {
    const { t } = useLanguage();
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [wishes, setWishes] = useState<Wish[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        // Load existing wishes when component mounts
        const loadWishes = async () => {
            try {
                const loadedWishes = await getWishes();
                setWishes(loadedWishes);
            } catch (err) {
                setError(t('wishes.error.loading'));
            }
        };
        loadWishes();
    }, [t]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const newWish = await createWish({
                title,
                description,
                guestId: 0 // This should be the ID of the logged-in guest
            });
            setWishes(prevWishes => [...prevWishes, newWish]);
            
            // Reset form
            setTitle('');
            setDescription('');
            setError(null);
        } catch (err) {
            setError(t('wishes.error.submit'));
        }
    };

    return (
        <div className="wishes-section">
            <div className="form-container">
                <form onSubmit={handleSubmit}>
                    <h2>{t('wishes.title')}</h2>
                    {error && <div className="error-message">{error}</div>}
                    <div className="form-group">
                        <label htmlFor="title">{t('wishes.title.input')}</label>
                        <input
                            type="text"
                            id="title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="input-field"
                            required
                            placeholder={t('wishes.title.placeholder')}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="description">{t('wishes.message')}</label>
                        <textarea
                            id="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="input-field wish-textarea"
                            rows={4}
                            required
                            placeholder={t('wishes.message.placeholder')}
                        />
                    </div>
                    <button type="submit" className="button">
                        {t('wishes.submit')}
                    </button>
                </form>
            </div>

            <div className="wishes-board">
                <h2>{t('wishes.board.title')}</h2>
                <div className="wishes-grid">
                    {wishes.map((wish, index) => (
                        <div key={index} className="wish-card">
                            <h3>{wish.title}</h3>
                            <p>{wish.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SendWish;